import React from 'react';
import BuilderSamplePercentage from '../../../../../components/Builder/BuilderFields/BuilderSamplePercentage';
import { useAppSelector } from '../../../../../redux/hooks';
import {
  DataTableQuerySettingKey,
  PermissionKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import AdditionalSettings from '../../../../../components/Builder/AdditionalSettings';
import {
  activeSchemaIdSelector,
  additionalSettingsSelector,
  defaultAdditionalSettingsSelector,
} from '../../../../../redux/selectors/builder';
import { BuilderHeader } from '../../../../../components/Builder/BuilderHeader';
import ThinDivider from '../../../../../components/ThinDivider';
import useShowLumosButton from '../../../../../components/LumosButton/useShowLumosButton';
import LumosButton from '../../../../../components/LumosButton';

const DataTableBuilderHeader = () => {
  const defaultAdditionalSettings = useAppSelector(
    defaultAdditionalSettingsSelector,
  );
  const additionalSettings = useAppSelector(additionalSettingsSelector);

  const checkSelectedSettings = (key: DataTableQuerySettingKey) =>
    additionalSettings.includes(key);

  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const shouldShowLumosButton = useShowLumosButton(
    activeSchemaId,
    PermissionKey.AnalysisCreate,
  );

  return (
    <BuilderHeader queryType={QueryType.DataTable}>
      {checkSelectedSettings(DataTableQuerySettingKey.Sampling) && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <BuilderSamplePercentage />
        </>
      )}

      {defaultAdditionalSettings.length > 0 && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <AdditionalSettings
            options={defaultAdditionalSettings}
            selectedKeys={additionalSettings}
          />
        </>
      )}
      {shouldShowLumosButton && <LumosButton />}
    </BuilderHeader>
  );
};

export default DataTableBuilderHeader;
